export default __webpack_public_path__ + "static/media/36I-102815_-16008_0.91866651.jpg";